import {LinearProgress, Box} from '@mui/material'
import {Component}           from 'react'
import styled                from 'styled-components'


class UploadFiles extends Component {
  constructor (props) {
    super(props)

    this.state = {
      selectedFiles: undefined,
      currentFile: undefined,
      progress: 0
    }

    this.selectFile = this.selectFile.bind(this)
  }

  selectFile (event) {
    event.preventDefault()
    const [file] = event.target.files
    if (file?.type.includes(this.props.file_type)) {
      this.props.onChange({...event, target: {...event.target, name: event.target.name, value: file}})
      this.setState({
        selectedFiles: file,
        currentFile: URL.createObjectURL(file)
      })
    }
  }

  componentDidUpdate (prevProps) {
    if (JSON.stringify(prevProps.value) !== JSON.stringify(this.props.value) && !!this.props.value) {
      this.setState({
        selectedFiles: this.props.value,
        currentFile: URL.createObjectURL(this.props.value)
      })
    } else if (JSON.stringify(prevProps.value) !== JSON.stringify(this.props.value) && !this.props.value) {
      this.setState({
        selectedFiles: undefined,
        currentFile: undefined
      })
    }
  }

  render () {
    const {
      selectedFiles,
      currentFile,
      progress
    } = this.state

    const {
      label,
      type,
      name,
      error,
      helperText,
      className
    } = this.props

    return (
      <div className={className}>
        <div className="row">
          <label className="col">
            <input name={name}
                   style={{display: 'none'}}
                   type={type}
                   onChange={this.selectFile}/>
            <span className="btn py-3 px-5 rounded text-12 border-blue text-green w-100"
                  color={error && 'error'}>
              <div>{currentFile ? 'تغییر' : 'آپلود'} {label}</div>
            </span>
          </label>
          {currentFile && <StyledImageContainer className="col-auto d-flex flex-column">
            {selectedFiles.type.includes('pdf') ?
             <embed src={currentFile}/> :
             selectedFiles.type.includes('image') ? <img src={currentFile} alt="preview"/> : ''}
          </StyledImageContainer>}
        </div>
        {error &&
          <StyledError>
            {helperText}
          </StyledError>
        }

        {false && currentFile && (
          <Box className="pt-3" display="flex" alignItems="center">
            <Box width="100%">
              <LinearProgress variant="determinate" value={progress}/>
            </Box>
          </Box>)
        }
      </div>
    )
  }
}

export default UploadFiles

const StyledError = styled.div`
  color: #d32f2f;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.66;
  letter-spacing: 0.03333em;
  font-family: inherit;
  text-align: right;
  margin: 10px 14px 0;
`

const StyledImageContainer = styled.div`
  width: 100px;
  max-height: 200px;
`
